import { Card, SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

interface IProps {}

const PurchaseOrderPageSkeletonLoader: FC = (props) => {
  return (
    <div className="space-y-4">
      <Card sizeVariant="lg">
        <Card.Body>
          <SkeletonLoader className="h-96 rounded-lg" />
        </Card.Body>
      </Card>
    </div>
  );
};

export default PurchaseOrderPageSkeletonLoader;
